const messageTimestamp = (message) => {
  const value = message?.createdAt;
  if (!value) return 0;
  if (value?.toDate) return value.toDate().getTime();
  if (value?._seconds) return value._seconds * 1000;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const mergeChatMessages = (existing = [], incoming = []) => {
  const byId = new Map();
  for (const message of [...existing, ...incoming]) {
    if (!message?.id) continue;
    byId.set(message.id, message);
  }
  return [...byId.values()].sort((a, b) => messageTimestamp(a) - messageTimestamp(b));
};
